import { useLanguageSwitcher } from 'hooks/useLanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { MenuItem, Select, styled } from 'shell/components';
import { LanguageList } from 'utils/constants';

const LanguageSelect = () => {
    const { t } = useTranslation('auth');
    const { currentLanguage, switchLanguage } = useLanguageSwitcher();

    const handleChange = (event) => {
        const nextLang = event.target.value;
        switchLanguage(nextLang);
    };

    return (
        <CustomSelect
            label={t('form.choose-language', 'Choose your language')}
            labelId='language-select'
            value={currentLanguage}
            onChange={handleChange}
        >
            {LanguageList.map((lang) => (
                <MenuItem key={lang.value} value={lang.value}>
                    {lang.label}
                </MenuItem>
            ))}
        </CustomSelect>
    );
};

const CustomSelect = styled(Select)(({ theme }) => {
    return {
        gap: theme.spacing(3),
        '& > .MuiFormLabel-root': {
            textAlign: 'center',
        },
        '& > .MuiInputBase-root': {
            width: '300px',
        },
    };
});

export default LanguageSelect;
